<template>
  <div class="wrap-box">
    <div class="content-box">
      <div class="card-box card-padding">
        <div class="card-title">
          {{ statusTxt }}
        </div>
        <div
          class="card-tips-warning"
          v-if="taskDetail.isPaicOrder === 1 || taskDetail.pingAnServiceFinishedPageConfig && taskDetail.pingAnServiceFinishedPageConfig.topPrompt"
        >
          <img
            src="@/assets/img/icon_warning.png"
            alt=""
          >
          <!-- <span class="tips-txt">请务必引导客户5星好评、再去好车主app打10分</span> -->
          <span class="tips-txt">
            {{ taskDetail.pingAnServiceFinishedPageConfig ? taskDetail.pingAnServiceFinishedPageConfig.topPrompt || topPromptDefaultText : topPromptDefaultText }}
          </span>
        </div>
        <div
          class="card-tips"
          v-else
        >
          备注:订单数据.上传需要一定时间， 上传完成前请不要关闭APP、切换账号
        </div>
        <van-divider
          dashed
          style="margin: 24px 0;"
        />
        <div class="task-info-box">
          <div class="task-info-item">
            <span class="item-label">任务编码</span>
            <span>{{ taskDetail.taskNo }}</span>
          </div>
          <div class="task-info-item">
            <span class="item-label">接单时间</span>
            <span>{{ taskDetail.takenTime }}</span>
          </div>
          <div class="task-info-item">
            <span class="item-label">任务用时</span>
            <span>{{ costTime }}</span>
          </div>
          <div class="task-info-item">
            <span class="item-label">任务地址</span>
            <span>{{ taskDetail.contactAddress }}</span>
          </div>
        </div>
      </div>
      <van-button
        type="info"
        size="large"
        @click="jumpToNativePage('homePage')"
      >返回首页</van-button>
    </div>
  </div>
</template>

<script>
import {
  getTaskDetail
} from '@/common/apiPaic.js';
import jsApi from '@/common/jsApi';

export default {
  data() {
    return {
      taskDetail: {
      },
      orderNo: '',
      taskNo: ''
    };
  },
  created() {
    const {
      orderNo,
      taskNo
    } = this.$route.params;
    if (orderNo && taskNo) {
      this.orderNo = orderNo;
      this.taskNo = taskNo;
    }
  },
  computed: {
    costTime() {
      const lastTakenTime = this.taskDetail.takenTime || '';
      const takenTime = new Date(lastTakenTime.replace(/-/g, '/'));
      const now = new Date();
      const costTime = now.getTime() - takenTime.getTime();
      if (isNaN(costTime)) {
        return '--';
      } else {
        const m = Math.ceil(costTime / 60000);
        return m + '分钟';
      }
    },
    statusTxt() {
      const statusTxtList = ['救援失败', '救援成功', '撤销有费', '撤销无费', '救援放空'];
      const index = this.taskDetail.rescueResult ? this.taskDetail.rescueResult : 0;
      return statusTxtList[index];
    },
    topPromptDefaultText() {
      if (this.taskDetail && this.taskDetail.isPaicOrder === 1) {
        return '请务必引导客户5星好评、再去好车主app打10分';
      }
      return '';
    }
  },
  mounted() {
    this.getTaskDetail();
  },
  methods: {
    async getTaskDetail(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
        }
        if (!noLoading) {
          this.$toast.clear();
        }
        try {
          if (this.taskDetail.appServiceType === 'RESCUE_NO_DESTINATION') {
            // 平安的，都弹，
            if (this.taskDetail.isPaicOrder === 1) {
              jsApi.showTakePhotoWindow({
                orderNo: this.orderNo,
                taskNo: this.taskNo
              });
            // 非平安的, 其中一个有值，就弹
            } else {
              if (this.taskDetail.pingAnServiceFinishedPageConfig && (this.taskDetail.pingAnServiceFinishedPageConfig.popUpImageUrl || this.taskDetail.pingAnServiceFinishedPageConfig.popUpPrompt)) {
                jsApi.showTakePhotoWindow({
                  orderNo: this.orderNo,
                  taskNo: this.taskNo
                });
              }
            }
          }
          const res = await jsApi.hiddenCancelByStatus({ taskStatus: this.taskDetail.taskStatus, appServiceType: this.taskDetail.appServiceType, orderNo: this.taskDetail.orderNo, taskNo: this.taskDetail.taskNo });
          if (res) {
            console.log(res);
          }
        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 跳转原生页面
    async jumpToNativePage(name, params = {}) {
      try {
        const res = await jsApi.jumpToNativePage({
          name,
          appServiceType: this.taskDetail.appServiceType,
          orderNo: this.orderNo,
          taskNo: this.taskNo,
          ...params
        });
        if (res) {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap-box{
  min-height: 100vh;

  background: #F2F3F5;
}
.content-box {
  padding: 12px;

  .task-info-box{
    background: #FFFFFF;

    .task-info-item{
      display: flex;

      letter-spacing: -0.38px;

      color: #383838;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;
      & + .task-info-item{
        padding-top: 12px;
      }
      .item-label{
        flex: 0 0 59px;

        margin-right: 15px;

        color: #787878;
      }
    }
  }

  .card-box{
    border-radius: 8px;
    background: #FFFFFF;

    .card-title{
      text-align: center;
      letter-spacing: -0.62px;

      color: #383838;

      font-family: PingFangSC-Medium;
      font-size: 24px;
      font-weight: 500;
      line-height: 33px;
    }

    .card-tips{
      margin-top: 24px;

      text-align: center;
      letter-spacing: -0.38px;

      color: #FF8A59;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;
    }

    & + .card-box{
      margin-top: 12px;
    }

    &.card-padding{
      padding: 24px 16px;
    }

    .card-tips-warning{
      display: flex;
      align-items: center;
      justify-content: center;

      margin-top: 24px;

      text-align: center;

      .tips-txt{
        margin-left: 5px;

        letter-spacing: -0.56px;

        color: #F32222;

        font-family: PingFangSC-Medium;
        font-size: 22px;
        font-weight: 500;
      }
    }
  }

  .van-button{
      text-align: center;
      letter-spacing: -0.38px;

      color: #FFFFFF;
      border-radius: 8px;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      &.van-button--info{
        border-color: #3399FF;
        background-color: #3399FF;
      }

      &.van-button--large{
        height: 40px;
      }
    }
}
</style>
